import { render, staticRenderFns } from "./PendingRegistration.vue?vue&type=template&id=b3221ae4"
import script from "./PendingRegistration.vue?vue&type=script&lang=js"
export * from "./PendingRegistration.vue?vue&type=script&lang=js"
import style0 from "./PendingRegistration.vue?vue&type=style&index=0&id=b3221ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports